import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    text: 'Die Ohrenentzündung ist komplett abgeklungen und sie kratzt sich deutlich weniger. Das Futtertopping schmeckt unserer Emma und bleibt nun Bestandteil der Ernährung.',
    author: 'Sarah & Emma'
  }, {
    text: 'Endlich ein Zusatz, der wirklich wirkt. Meine Hündin ist sichtbar fitter, aktiver, wacher – ohne Verdauungsprobleme.',
    author: 'Nadja & Sonnenblume'
  }, {
    text: 'Viele Jahre viel Geld ausgegeben. Nichts hat geholfen. Um so überraschter war ich, als schon nach 3-4 Wochen Besserung eintrat.',
    author: 'Martina aus München'
  }];
  return <section className="w-full py-16 px-4 md:px-8 bg-offWhite border-y border-warmBrown/10" data-id="element-93">
      <div className="max-w-4xl mx-auto" data-id="element-94">
        <h2 className="font-handwritten text-4xl text-center text-forestGreen font-bold mb-12" data-id="element-95">
          Erfahrungen anderer Hundehalter
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-96">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-warmBrown/5 flex flex-col" data-id="element-97">
              <div className="flex gap-1 mb-4 text-amber-400" data-id="element-98">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} fill="currentColor" data-id="element-99" />)}
              </div>

              <p className="font-serif text-gray-700 italic leading-relaxed mb-6 flex-grow" data-id="element-100">
                "{review.text}"
              </p>

              <p className="font-bold font-serif text-forestGreen text-sm" data-id="element-101">
                – {review.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}